// Mock data for LocaLeap

export const saleInfo = {
  code: "LAUNCH25",
  discount: "25%",
  daysLeft: 3,
  endDate: new Date(Date.now() + 3 * 24 * 60 * 60 * 1000),
};

export const testimonialAvatars = [
  { name: "Sarah", image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=face" },
  { name: "Mike", image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face" },
  { name: "Jessica", image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=100&h=100&fit=crop&crop=face" },
  { name: "David", image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face" },
  { name: "Emma", image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face" },
  { name: "Chris", image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&crop=face" },
];

export const howItWorksSteps = [
  {
    step: 1,
    title: "Enter your business details",
    description: "Tell us about your company, target market, competitors, and goals. Our AI needs just the basics to get started.",
  },
  {
    step: 2,
    title: "AI analyzes your market",
    description: "Our engine scans competitor reviews, market positioning, and local insights to build your unique strategy.",
  },
  {
    step: 3,
    title: "Get your actionable playbook",
    description: "Receive a complete brand strategy with positioning, messaging, campaigns, and local competitive analysis.",
  },
];

export const brandAnalysisFeatures = [
  {
    title: "Brand Positioning",
    description: "Define your unique space in the market.",
    items: [
      "Clear positioning statement",
      "Unique value proposition",
      "Brand archetype & personality",
      "Compelling tagline options",
    ],
  },
  {
    title: "Local Brand Analysis",
    description: "Understand your local market inside out.",
    items: [
      "Google Business Profile optimization",
      "Competitor sentiment tracking",
      "Market gap identification",
      "Differentiation opportunities",
    ],
  },
  {
    title: "Go-to-Market Strategy",
    description: "Actionable plans to reach your audience.",
    items: [
      "Ideal customer profiles",
      "Channel-specific messaging",
      "Campaign concepts",
      "Content strategy pillars",
    ],
  },
];

export const marketingProblems = [
  {
    problem: "Your brand blends in with competitors",
    solution: "LocaLeap's AI identifies your unique differentiators and crafts positioning that makes you stand out in your local market.",
  },
  {
    problem: "You don't know what customers really think",
    solution: "We analyze Google Reviews for you and your competitors, revealing sentiment patterns and opportunities to improve.",
  },
  {
    problem: "Marketing feels scattered and ineffective",
    solution: "Get a cohesive strategy with clear messaging, targeted campaigns, and channel recommendations that actually work.",
  },
  {
    problem: "Competitors seem to get all the attention",
    solution: "Our competitive analysis shows exactly where rivals are weak and how you can capture their unhappy customers.",
  },
  {
    problem: "You're not sure who your ideal customer is",
    solution: "We build detailed customer profiles with demographics, pain points, and exactly where to find them online.",
  },
  {
    problem: "Brand messaging is inconsistent",
    solution: "Define your brand voice once, then apply it consistently across every touchpoint with our messaging framework.",
  },
];

export const pricingPlans = [
  {
    name: "Starter Report",
    tagline: "Perfect for Small Businesses",
    price: "$97",
    period: "one-time",
    features: ["Complete brand strategy", "Competitor analysis", "Google Reviews insights", "PDF download"],
    cta: "Generate My Strategy",
    popular: false,
  },
  {
    name: "Growth Package",
    tagline: "For Ambitious Local Businesses",
    price: "$297",
    period: "one-time",
    features: ["Everything in Starter", "3 report generations", "Priority processing", "Campaign templates"],
    cta: "Start Growing",
    popular: true,
  },
];

export const testimonials = [
  {
    quote: "LocaLeap completely transformed how we think about our brand. The competitor insights alone were worth 10x the price.",
    author: "Sarah Chen",
    role: "Founder, Local Bakery Co",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=face",
  },
  {
    quote: "Finally, a tool that actually understands local business. The Google Reviews analysis helped us fix issues we didn't even know we had.",
    author: "Marcus Johnson",
    role: "Owner, Johnson's Auto",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face",
  },
  {
    quote: "We used the campaign ideas and saw a 40% increase in foot traffic within two months. This is a game-changer for local businesses.",
    author: "Emily Rodriguez",
    role: "Marketing Director, FitZone Gym",
    image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=100&h=100&fit=crop&crop=face",
  },
  {
    quote: "The brand positioning section gave us clarity we've been searching for years. Now we know exactly how to communicate our value.",
    author: "David Park",
    role: "CEO, TechRepair Pro",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face",
  },
  {
    quote: "I was skeptical about AI-generated strategies, but LocaLeap delivered insights that rival expensive consulting firms.",
    author: "Jessica Williams",
    role: "Founder, Bloom Flowers",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face",
  },
];

export const features = [
  "Brand Positioning Matrix - Visualize your unique market position",
  "Google Business Profile - Optimization tips and competitive comparison",
  "SWOT Analysis - Comprehensive strengths, weaknesses, opportunities, threats",
  "Competitor Intelligence - Deep dive into rival strategies and weaknesses",
  "Brand Archetype - Discover your brand's core personality",
  "Customer Personas - Detailed ideal customer profiles with pain points",
  "Marketing Campaigns - Ready-to-execute campaign ideas with tactics",
  "Content Strategy - Pillar topics and channel recommendations",
  "Brand Voice Guide - Tone, messaging dos and don'ts",
  "Local Market Insights - Understand your geographic competitive landscape",
  "Tagline Generator - Multiple compelling tagline options",
  "Elevator Pitch - Craft the perfect 30-second pitch",
];

export const faqItems = [
  {
    question: "How does LocaLeap generate brand strategies?",
    answer: "We use advanced AI (Claude) combined with real-time data from Google Business Profiles and market analysis to create comprehensive, actionable brand strategies tailored to your specific business and local market.",
  },
  {
    question: "What's included in the Google Business Profile analysis?",
    answer: "We analyze your Google Business Profile completeness, rating, review count, and compare it against competitors. You get actionable recommendations to improve your local visibility and attract more customers.",
  },
  {
    question: "How long does it take to generate a report?",
    answer: "Most reports are generated in 1-2 minutes. We analyze your inputs, fetch competitor data, and use AI to create a comprehensive strategy during this time.",
  },
  {
    question: "Can I download and share my report?",
    answer: "Yes! Every report can be downloaded as a professional PDF that's perfect for sharing with your team, partners, or stakeholders. The PDF includes all sections with professional formatting.",
  },
  {
    question: "Is LocaLeap really free?",
    answer: "Yes! During our beta period, LocaLeap is completely free. We're gathering feedback to make the tool even better. Get your free brand strategy report while this offer lasts.",
  },
];

export const navLinks = [
  { name: "How It Works", href: "#how-it-works" },
  { name: "Features", href: "#features" },
  { name: "FAQ", href: "#faq" },
];
